"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfClient = void 0;
exports.downloadReport = downloadReport;
exports.requestAndPollReport = requestAndPollReport;
const BaseClient_1 = require("../BaseClient");
class PdfClient extends BaseClient_1.BaseClient {
    constructor(baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
    }
    /**
     * Start new PDF document generation
     * @param pdfRequest is passed to callback onGetUserJwtParams
     */
    async requestReport(pdfRequest) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/pdf/post',
            data: pdfRequest,
        });
        return response.data;
    }
    /**
     * Check the status of a job
     */
    async getStatus(jobId) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/pdf/status',
            params: {
                jobId,
            },
        });
        return response.data;
    }
}
exports.PdfClient = PdfClient;
/**
 * Download the pdf file associated with a given job id
 * @param jobId
 * @param downloadFileName
 */
async function downloadReport(jobId, downloadFileName) {
    if (BaseClient_1.baseClientDefaults.tokenProvider) {
        const jwt = await BaseClient_1.baseClientDefaults.tokenProvider.onTokenRequest();
        downloadReportUsingJwt(jobId, jwt, downloadFileName);
    }
    else {
        window.open(getReportUrl(jobId, downloadFileName), '_blank');
    }
}
function downloadReportUsingJwt(jobId, jwt, downloadFileName) {
    const form = document.createElement('form');
    form.method = 'post';
    form.target = '_blank';
    form.action = BaseClient_1.baseClientDefaults.baseUrl + '/api/v1/pdf/result';
    const inputs = [];
    inputs.push(`<input type="hidden" name="jobId" value="${jobId}">`);
    inputs.push(`<input type="hidden" name="jwt" value="${jwt}">`);
    if (downloadFileName) {
        inputs.push(`<input type="hidden" name="downloadFileName" value="${downloadFileName}">`);
    }
    form.innerHTML = inputs.join();
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
}
function getReportUrl(jobId, downloadFileName) {
    const downloadFileNameParam = downloadFileName ? '&downloadFileName=' + encodeURIComponent(downloadFileName) : '';
    return `${BaseClient_1.baseClientDefaults.baseUrl}/api/v1/pdf/result?jobId=${jobId}${downloadFileNameParam}`;
}
async function requestAndPollReport(pdfRequest) {
    const pdfClient = new PdfClient();
    const { jobId } = await pdfClient.requestReport(pdfRequest);
    const status = await pollReportStatus(pdfClient, jobId);
    return { jobId, ...status };
}
async function pollReportStatus(pdfClient, jobId) {
    let response = await pdfClient.getStatus(jobId);
    while (response.status === 'InProgress') {
        await new Promise((resolve) => {
            setTimeout(resolve, 1000);
        });
        response = await pdfClient.getStatus(jobId);
    }
    return response;
}
